module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAkCAYAAACqqEt1AAAAlElEQVR4nO2QsQnCYBSEv/dICl1AcAJHCIgj2P69hdgoJGArZoOAS9ha2gTsXCBrWKX2PytFxJSCgl95HHfcQQcGsMzzsctmQqm57XdVdbRVUUyJHCT53e3OPCFqI+HPMYpsXdjwNV8wcEP1m+aT0++tMc4PzWhIk4UBlGXpl7YdIaWTLGtCCNeuGV/K/91P8mPv3gD1E3TpGfC65AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/Group 2.png
// module id = 830
// module chunks = 0